export default __webpack_public_path__ + "static/media/background3.3bcd14d1.jpg";